export default __webpack_public_path__ + "static/index_about_camera-784045e9312296e57534660ce1f1d7c9.png";